<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('NAME')">
        <inputvalidation :formerror="formError" name="name">
          <b-form-input type="text" v-model="formData.name"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('OBJECTNAME')">
        <inputvalidation :formerror="formError" name="objectNameId">
             <lb-vue-select v-model= "formData.objectNameId"
                            :list= "objectName.root"
                            display-field= "name"
                            value-field= "objectNameId"
                            :items-placeholder= "$t('OBJECTNAME')">
              </lb-vue-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
import ObjectNameApi from '@/api/object_name/ObjectName';

export default
{
    name: 'EducationalGroupForm',
    props: ['formData', 'formError'],
    data()
    {
        return {
            objectName: {},
        };
    },
    created()
    {
        const me = this;
        me.getObjectName();
    },

    methods:
    {
        async getObjectName()
        {
            const me = this;
            try
            {
                const data = await ObjectNameApi.selectRow();
                if (data.error && data.error === true)
                {
                    me.$notify.notice(data);
                    me.loading = false;
                    return;
                }

                me.objectName = data;
            }
            catch (e)
            {
                me.$notify.notice(e);
            }
        },
    },
};
</script>
